import React from 'react';
import InputGroup from '../../../../../components/form/InputGroup';
import SelectInput from '../../../../../components/form/selects/SelectInput';
import { monthsSelectOption, yearsSelectOption } from '../../../../../data/craditCardForm.data';
import useRenewedPermitModalFunctions from '../../../../../hooks/useRenewedPermitModalFunctions';
import { useModalRenewedPermitData } from '../../../../../stores/renewedPermitModal.store';
import { formatCurrencyNis } from '../../../../../helpers/formating-currency';
import { useTags } from '../../../../../hooks/useTags';
import renewedPermitModalLang from '../../../../../data/lang/homePage/renewedPermitModal.lang';



function CreditCardFormSection() {

    const { handleBlurRenewedPermitInput,
        handleSetRenewedPermitFormStr } = useRenewedPermitModalFunctions();
    const renewedPermitData = useModalRenewedPermitData();
    const { form, permitFee } = renewedPermitData;
    const { values, errors, touched } = form;

    const hasPayment = permitFee > 0 ? true : false;

    const moneyFormetted = formatCurrencyNis(permitFee);
    const generateTag = useTags();
    const title = generateTag(renewedPermitModalLang, 'form.credit-card.section-title') + ` - ${moneyFormetted}`;
    const cardNumberLabel = generateTag(renewedPermitModalLang, 'form.credit-card.card-number-label');
    const cardExpireYearLabel = generateTag(renewedPermitModalLang, 'form.credit-card.card-expire-year-label');
    const cardExpireMonthLabel = generateTag(renewedPermitModalLang, 'form.credit-card.card-expire-month-label');
    const cardCVVLabel = generateTag(renewedPermitModalLang, 'form.credit-card.card-cvv-label');
    const cardHolderIdLabel = generateTag(renewedPermitModalLang, 'form.credit-card.card-holder-id-label');
    const cardHolderNameLabel = generateTag(renewedPermitModalLang, 'form.credit-card.card-holder-name-label');

    if (!hasPayment) {
        return null;
    }

    return (
        <div className='mb-4'>
            <h4 style={{ fontStyle: 'italic' }}>
                {title}
            </h4>

            <div className='row'>
                <div className='col-12'>
                    <InputGroup
                        name={'cardNumber'}
                        label={cardNumberLabel}
                        value={values.cardNumber}
                        handleBlur={handleBlurRenewedPermitInput}
                        handleChange={handleSetRenewedPermitFormStr}
                        isRequired={true}
                        errorMsg={
                            errors?.cardNumber && touched?.cardNumber
                                ? errors.cardNumber
                                : undefined
                        }
                    />
                </div>
                <div className='col-6 col-md-4'>
                    <SelectInput
                        name={'cardExpireDateYY'}
                        label={cardExpireYearLabel}
                        value={values.cardExpireDateYY}
                        onBlur={handleBlurRenewedPermitInput}
                        onChange={handleSetRenewedPermitFormStr}
                        selects={yearsSelectOption}
                        required={true}
                        errorMsg={
                            errors?.cardExpireDateYY && touched?.cardExpireDateYY
                                ? errors.cardExpireDateYY
                                : undefined
                        }
                    />
                </div>
                <div className='col-6 col-md-4'>
                    <SelectInput
                        name={'cardExpireDateMM'}
                        label={cardExpireMonthLabel}
                        value={values.cardExpireDateMM}
                        onBlur={handleBlurRenewedPermitInput}
                        onChange={handleSetRenewedPermitFormStr}
                        selects={monthsSelectOption}
                        required={true}
                        errorMsg={
                            errors?.cardExpireDateMM && touched?.cardExpireDateMM
                                ? errors.cardExpireDateMM
                                : undefined
                        }
                    />
                </div>
                <div className='col-6 col-md-4'>
                    <InputGroup
                        name={'cardAddedNumber'}
                        label={cardCVVLabel}
                        value={values.cardAddedNumber}
                        handleBlur={handleBlurRenewedPermitInput}
                        handleChange={handleSetRenewedPermitFormStr}
                        isRequired={true}
                        errorMsg={
                            errors?.cardAddedNumber && touched?.cardAddedNumber
                                ? errors.cardAddedNumber
                                : undefined
                        }
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <InputGroup
                        name={'cardHolderId'}
                        label={cardHolderIdLabel}
                        value={values.cardHolderId}
                        handleBlur={handleBlurRenewedPermitInput}
                        handleChange={handleSetRenewedPermitFormStr}
                        isRequired={true}
                        errorMsg={
                            errors?.cardHolderId && touched?.cardHolderId
                                ? errors.cardHolderId
                                : undefined
                        }
                    />
                </div>
                <div className='col-12'>
                    <InputGroup
                        name={'cardHolderName'}
                        label={cardHolderNameLabel}
                        value={values.cardHolderName}
                        handleBlur={handleBlurRenewedPermitInput}
                        handleChange={handleSetRenewedPermitFormStr}
                        isRequired={true}
                        errorMsg={
                            errors?.cardHolderName && touched?.cardHolderName
                                ? errors.cardHolderName
                                : undefined
                        }
                    />
                </div>
            </div>

        </div>
    );
}

export default CreditCardFormSection;